import classNames from "classnames";

export default function Logo({
  className,
  variant = "mark",
  ...props
}: React.ImgHTMLAttributes<HTMLImageElement> & {
  variant?: "mark" | "full";
}) {
  const src = variant === "full" ? "/logo.svg" : "/icon.svg";
  const darkSrc = variant === "full" ? "/logo-dark.svg" : "/icon.svg";

  return (
    <>
      <img
        src={src}
        alt=""
        aria-hidden="true"
        className={classNames("object-contain dark:hidden", className)}
        {...props}
      />
      <img
        src={darkSrc}
        alt=""
        aria-hidden="true"
        className={classNames("hidden object-contain dark:block", className)}
        {...props}
      />
    </>
  );
}
